// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee671459","787":"b8c2b187"}[chunkId] + ".chunk.js";
};